import { statsData } from '@/mocks/home';

export default function StatsSection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center p-5 rounded-xl bg-background-100">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${stat.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}